<script>
  import { GridContainer, GridColumn, Separator } from '@qlean/ui-kit-web-svelte'

  import classNames from 'classnames/bind'

  import css from './_styles'

  const cN = classNames.bind(css)

  export let config

  const content = config.content
</script>

<div class={cN('info-banner', { 'info-banner--hidden': !content })}>
  <GridContainer>
    <GridColumn width={0} widthMiddle={1} />
    <GridColumn widthMiddle={10} class={cN('info-banner__text-container')}>
      <Separator key={10} size={Separator.SIZES.SMALL} />
      {@html content}
      <Separator key={10} size={Separator.SIZES.SMALL} />
    </GridColumn>
    <GridColumn width={0} widthMiddle={1} />
  </GridContainer>
</div>
